/**
 * 客户余额
 *
 * @author FJJ
 * @version 1.0
 *
 * Copyright 2022, all rights reserved. Essa.cn
 * */

import React from 'react'
import CommonBreadcrumb from "@components/CommonBreadcrumb";
import Lang from "@components/Lang/Lang";
import dayjs from "dayjs";
import AutoFetchTable from "@components/AutoFetchTable/AutoFetchTable";
import CashOutModal from "../component/CashOutModal​";
import {isEmpty,symbolMoneyUtil} from '@utils/utils';
import qs from 'query-string';
import "./customerBalance.less";
import FnanceAction from "../Fnance.action";
class CustomerBalanceDetail extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            //加载中
            loading: true,
            // 列
            columns: [
                {
                    cnTitle: '时间',
                    cnTitleId: 'ShiJian',
                    width: 200,
                    fixed: "left",
                    dataIndex: 'happenTime',
                    render: (happenTime, record, index) => (
                        <div key={index}>
                            <p>{happenTime? dayjs(happenTime).format("YYYY-MM-DD HH:mm:ss"): "-"}</p>
                            {/*<p className={"con2-txt"}>ID<span className={"ml_4"}>{record.id}</span></p>*/}
                        </div>
                    ),
                },
                {
                    cnTitle: '说明',
                    cnTitleId: 'ShuoMing',
                    dataIndex: 'remark',
                    width: 250,
                    render: (remark, record, index) => (<div className={"con2-txt"}>
                        {record.bizCode&&<span className={"mr_8"}>{record.bizCode}</span>}<span>{remark || "-"}</span>
                    </div>),
                },
                {
                    cnTitle: '状态',
                    cnTitleId: 'ZhuangTai',
                    dataIndex: 'inOutType',
                    render: (inOutType, record, index) => {
                        return (<div>{inOutType==1?<span className={"greedLabel"}>
                            <i className="ri-add-line"></i>
                            {Lang({id: 'Jia', default: '加'})}
                        </span>:(inOutType=='-1'?<span className={"redLabel"}>
                            <i className="ri-subtract-line"></i>
                            {Lang({id: 'Jian2', default: '减'})}
                        </span>:'')}</div>)
                    },
                },
                {
                    cnTitle: '收入',
                    cnTitleId: 'ShouRu',
                    dataIndex: 'marginAmount',
                    render: (marginAmount, record, index) => (
                        <span className={"fw_500 greenColor"}>{record.inOutType==1&&!isEmpty(record.marginAmount)?symbolMoneyUtil(record.marginAmount, record.currencySymbol):''}</span>
                    ),
                },
                {
                    cnTitle: '支出',
                    cnTitleId: 'ZhiChu',
                    dataIndex: 'marginAmount2',
                    render: (marginAmount2, record, index) => (
                        <span className={"fw_500 redColor"}>{record.inOutType=="-1"&&!isEmpty(record.marginAmount)?symbolMoneyUtil(record.marginAmount, record.currencySymbol):''}</span>
                    ),
                },
                {
                    cnTitle: '余额',
                    cnTitleId: 'YuE',
                    dataIndex: 'balanceAfter',
                    render: (balanceAfter, record, index) => (
                        <span className={"fw_500"}>{!isEmpty(record.balanceAfter)?symbolMoneyUtil(record.balanceAfter, record.currencySymbol):''}</span>
                    ),
                },
            ],
            searchFormOptions:[
                {
                    name:'inOutType',
                    cnTitle:'类型',
                    cnTitleId:'LeiXing',
                    cnPlaceholder:'请选择类型',
                    cnPlaceholderId:'QingXuanZeLeiXing',
                    type:'Enum',
                    // canSearch:true, // 选择搜索,
                    enumClass:'fin_in_out_type',
                    hiddenLabel:true,
                    enumCanAll:true,
                    width:150,
                    // excludeValue:['-10','110']
                },
                // {
                //     name:'keyword',
                //     cnPlaceholder:'搜索客户编号',
                //     cnPlaceholderId:'SouSuoKeHuBianHao',
                //     hiddenLabel:true,
                //     // type:'SearchInput'
                // },
                {
                    name:'poCode',
                    cnPlaceholder:'请输入PO单号',
                    cnPlaceholderId:'QingShuRuPODanHao',
                    hiddenLabel:true,
                    // type:'SearchInput'
                },
                {
                    name:'time',
                    cnPlaceholder:[Lang({id:'KaiShiShiJian',default:'开始时间'}),Lang({id:'JieShuShiJian',default:'结束时间'})],
                    cnPlaceholderId:['KaiShiShiJian','JieShuShiJian'],
                    searchRange:['startTime','endTime'],
                    type:'DateRangePicker',
                    width:300,
                    hiddenLabel:true,
                    canSearch:false,
                },
            ],
        };
    }
    fetchOne(id){
        this.loading(true);
        const postData = {
            buyerId: id,
        }
        FnanceAction.getCustomerBalance(postData).then(res=>this.handleRes(res.data)).catch(err=>this.handleRes(err));
    }
    /**
     * 加载
     * */
    loading(flag) {
        this.setState({
            loading: flag,
        });
    }
    handleRes(res) {
        const {success, valid, model = {}} = res;
        if (success && valid) {
            this.setState({
                cusModel:model
            })
        }
    }
    /**
     * 刷新
     *
     */
    refreshPage(){
        const { buyerId } = this.state;
        this.onRefTabChildOne.handleFetch(1,{},true);
        this.fetchOne(buyerId);
    }
    onRefTabOne = (ref) =>  this.onRefTabChildOne = ref;
    componentWillMount(){
        const {id} = qs.parse(this.props.location.search);
        this.setState({
            buyerId:id
        })
        this.fetchOne(id)
    }
    componentDidMount() {
    }
    render(){
        const { columns,searchFormOptions,cusModel={},buyerId } = this.state;
        return (
            <>
                <CommonBreadcrumb
                    list={[
                        {
                            name: Lang({id: 'KeHuZiJinMingXi', default: '客户资金明细'}),
                            link: "/financeManagement/customerBalance",
                        },
                        { name: cusModel.buyerCode }
                    ]}
                ></CommonBreadcrumb>
                <div className={"main-wrap customerBalanceWrap"}>
                    <div className={"flex-item halfBox mb_16"}>
                        <div className="halfItem">
                            <div>
                                <div>{Lang({id: 'QianBaoYuE', default: '钱包余额'})}</div>
                                <div className={"flex-item-ver-center"}>
                                    <img src={"https://oss.essaone.com/1241fcf1-150a-470b-8ced-333a17edf9e0.png"} />
                                    <span className={"ml_8 mr_8 fw_700 black89 font_18"}>{!isEmpty(cusModel.ddpBalance)?symbolMoneyUtil(cusModel.ddpBalance, cusModel.currencySymbol):'-'}</span>
                                    {/*<span></span>*/}
                                    <CashOutModal buyerId={buyerId} cusModel={cusModel} refreshPage={()=>this.refreshPage()} />
                                </div>
                            </div>
                        </div>
                        <div className="halfItem pinkBox">
                            <div>
                                <div>{Lang({id: 'DaiFuKuan', default: '待支付'})}</div>
                                <div className={"flex-item"}>
                                    <img src={"https://oss.essaone.com/b353ff53-26e6-475d-9188-59710be6ca68.png"} />
                                    <span className={"ml_8 mr_8 fw_700 black89 font_18"}>{!isEmpty(cusModel.payableAmount)?symbolMoneyUtil(cusModel.payableAmount, cusModel.currencySymbol):'-'}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/*表格*/}
                    {buyerId?<AutoFetchTable columns={columns}
                                    precondition={
                                        {
                                            inOutType:'', // 类型 默认为空
                                            buyerId:buyerId
                                        }
                                    }
                                    exportSetting = {
                                        {
                                            exportUrl: '/data/bpms/jreport/mg/fexiao/fin/walletItem/print',
                                            exportTemplate: 'MgFenxiaoWelleItemReport',
                                            authName:'CustomerBalance-Export-Button',
                                            otherParams:{
                                                buyerId:buyerId
                                            }
                                        }
                                    }
                                    searchFormOptions={searchFormOptions}
                                    onRef={this.onRefTabOne}
                                    scroll={{ x: 800 }}
                                    flagShowReset = {false}
                                    pageSize={10}
                                    fetchApi={'/service/mg/fin/ddp/wallet/item-list'}>
                    </AutoFetchTable>:null}
                </div>
            </>
        )
    }
}

export default CustomerBalanceDetail;

